import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

import { HarmonyAppDefinition } from '@office-start/app-host-types';
import AppBarComponent from '@office-start/appbar-component';
import * as React from 'react';
import { Observable } from 'rxjs';

import { m365AppDefinitionsBehaviorSubject } from '@office-start/m365-apps-service';
import { PaintMarkerName } from '../shared/models/paint-marker-name.enum';
import { bootstrapOfficeStartComponent } from '../shared/office-start/bootstrap-office-start-component';
import { OfficeStartBootstrapperService } from '../shared/office-start/office-start-bootstrapper.service';
import ReactRenderer from '../shared/react/react-renderer';
import { AppBarConnectorServiceInjectable } from '../shared/services/appbar-connector.service.injectable';
import { BrowserPaintMeasurementService } from '../shared/services/browser-paint-measurement.service';
import { EventService } from '../shared/services/event.service';
import { ThemingService } from '../shared/services/theming.service';
import { AngularEvents } from '../shared/shared-context/angular-events';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';

@Directive({ selector: 'ohp-appbar-content' })
export class AppBarContentDirective extends ReactRenderer implements OnInit, OnDestroy {
    public remoteModulesEnabled: boolean;
    public m365AppsEnabled: boolean;
    public appDefinitions: Observable<ReadonlyArray<HarmonyAppDefinition>>;

    constructor(
        elementRef: ElementRef,
        capabilitiesService: CapabilitiesService,
        private readonly eventService: EventService,
        officeStartBootstrapperService: OfficeStartBootstrapperService,
        themingService: ThemingService,
        private readonly appbarConnectorServiceInjectable: AppBarConnectorServiceInjectable,
        private readonly browserPaintMeasurementService: BrowserPaintMeasurementService
    ) {
        super(elementRef);
        bootstrapOfficeStartComponent(officeStartBootstrapperService, themingService);
        this.remoteModulesEnabled = capabilitiesService.capabilities.remoteModulesEnabled;
        this.m365AppsEnabled = capabilitiesService.capabilities.m365AppsEnabled;
        this.appDefinitions = m365AppDefinitionsBehaviorSubject;
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public async getReactElement() {
        this.eventService.broadcastEvent({
            name: AngularEvents.appBarReady,
            args: []
        });

        this.browserPaintMeasurementService.recordWhenPainted(PaintMarkerName.AppBar);

        return (
            <AppBarComponent
                allowRemote={this.remoteModulesEnabled}
                appDefinitions={this.m365AppsEnabled ? this.appDefinitions : undefined}
                appbarConnectorService={this.appbarConnectorServiceInjectable.getAppbarConnectorService()}
            />
        );
    }
}
